<template>
  <div class="order-wrapper payment-wrapper"
    v-bind:class="{ 'is-active': openSlideleft }">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="Menu"
        :buttonsList="getReportButtons"
        :selectedCategory="selectedCategory"
        :noSearchFilter="true"
        v-on:generateReport="generateReport"/>
    </portal>
    <div class="flex-container page-filter">
      <div class="flex-item">
        <FilterWrapper
          :values="filterTags"
          @openSliderLeft="openSlideleft = !openSlideleft">
        </FilterWrapper>
      </div>
    </div>
    <div class="top slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
      <div class="slideleft_content">
        <div class="content">
          <ReportContent
            :isDepotSet="isDepotSet"
            :resetRadio="resetRadio"
            :isTransporterSet="isTransporterSet"
            :movementSet="movementSet"
            :dateFilterError="getDateFilterError"
            v-on:reportChange="reportChange" />
        </div>
      </div>
      <div class="slideleft_menu">
        <SecFilter
          v-if="!transporterLoading"
          :selectedFilters="filterConstant"
          :filters="filters"
          :disableApply="true"
          v-on:updateOption = "updateOptionWithGA"
          v-on:reset = "resetApply"
          v-on:clearDate = "clearDate"
          v-on:clearAllGA= "clearAllGA"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FilterWrapper from '@common/components/FilterWrapperV2';
import { Menu, reportButtons, reports, filters } from '@/constants/reportConstants';
import { movementTypeMenu } from '@/constants/order';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import Info from '../../reports/action/Info';
import ReportContent from '../../reports/ReportContent';
import moment from 'moment';

export default {
  components: {
    PrimaryFilter,
    Info,
    ReportContent,
    SecFilter,
    FilterWrapper,
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      openSlideleft: true,
      defaultValues: {},
      dateFilterError: false,
      Menu,
      reportButtons,
      transporters: [],
      transporterLoading: false,
      transporterList: [],
      selectedReport: 0,
      reports,
      filterConstant: [],
      filters,
      singleDayReports: ['Optima Variance', 'Optima Variance Summary'],
      hasGACapture: true,
      resetRadio: false,
      movementTypeMenu,
    };
  },
  async created() {
    this.transporterLoading = true;
    const list = await this.$store.dispatch('dashboard/transporterlist');
    if (list) {
      list.unshift({ id: -1, name: 'All Transporters', tlabel: 'INDENT_ALL_TRANSPORTER' });
      this.transporterList = list;
    }
    if (this.configurations.inboundConfig) {
      const allowedMovementTypes = this.movementTypeMenu.filter(_movementType =>
        (_movementType.check_config
          ? this.configurations.inboundConfig[_movementType.check_config]
          : true),
      );
      this.movementType = allowedMovementTypes;
    }
    this.transporterLoading = false;
    this.setDefaults();
    this.constructConstantForFilter();
    this.applyFilters();
  },
  computed: {
    ...mapGetters({
      depots: 'app/depots',
      configurations: 'app/configurations',
    }),
    selectedCategory() {
      return this.Menu[0];
    },
    isDepotSet() {
      const depot = this.findByCategory(this.filters.DEPOT);
      return depot && (depot.length != 0);
    },
    isTransporterSet() {
      const transporter = this.findByCategory(this.filters.TRANSPORTER);
      return transporter && (transporter.id != -1);
    },
    movementSet() {
      const movement = this.findByCategory(this.filters.MOVEMENT);
      return movement && (movement.id != -1);
    },
    getDateFilterError() {
      const dateFilter = this.findByCategory(this.filters.DATE);
      if (this.selectedReport && (this.singleDayReports.includes(this.reports[this.selectedReport - 1].name)) && dateFilter.startDate !== dateFilter.endDate) {
        this.dateFilterError = true;
      } else {
        this.dateFilterError = false;
      }
      return this.dateFilterError;
    },
    getReportButtons() {
      const buttonList = this.reportButtons;
      const buttonIndex = this.reportButtons.findIndex(button => button.name === 'Generate Report');
      if (this.dateFilterError || (this.selectedReport === 0)) {
        buttonList[buttonIndex].disabled = true;
      } else {
        buttonList[buttonIndex].disabled = false;
      }
      return buttonList;
    },
    filterParams() {
      return this.filterConstant && this.filterConstant.flat();
    },
  },
  methods: {
    resetSelectedReport() {
      this.resetRadio = !this.resetRadio;
      this.selectedReport = 0;
    },
    setDefaults() {
      this.defaultValues.depot = [];
      this.defaultValues.depot.push(this.depots[0]);
      [this.defaultValues.transporter] = this.transporterList;
      this.defaultValues.endDate = moment().toString();
      this.defaultValues.startDate = moment().subtract(89, 'days').toString();
      this.defaultValues.movement = this.movementTypeMenu[0];
    },

    constructConstantForFilter() {
      this.filterConstant = [
        [
          {
            type: 'MultiSelectList',
            category: this.filters.DEPOT,
            default: this.defaultValues.depot,
            selected: this.defaultValues.depot,
            list: this.depots,
            idLabel: 'id',
            optional: false,
            clearSelected: true,
            selectAllOption: true,
            queryParamString: 'depot_id',
            placeholder: 'Select depots',
          },
          {
            type: 'Date',
            category: this.filters.DATE,
            defaultStartDate: this.defaultValues.startDate,
            defaultEndDate: this.defaultValues.endDate,
            startDate: this.defaultValues.startDate,
            endDate: this.defaultValues.endDate,
            start_date_label: 'start',
            end_date_label: 'end',
            optional: false,
            maxDays: 366,
          },
          {
            type: 'List',
            category: this.filters.TRANSPORTER,
            default: this.defaultValues.transporter,
            selected: this.defaultValues.transporter,
            list: this.transporterList,
            idLabel: 'id',
            queryParamString: 'transporter_id',
            optional: false,
          },
          {
            type: 'List',
            category: this.filters.MOVEMENT,
            default: this.defaultValues.movement,
            selected: this.defaultValues.movement,
            list: this.movementType,
            idLabel: 'id',
            queryParamString: 'movement',
            optional: false,
          },
        ],
      ];
      if (this.$hasFeature('remove_movement_filter')) {
        this.filterConstant[0] = this.filterConstant[0].filter(category => category.category !== this.filters.MOVEMENT);
      }
      if (this.$hasFeature('shipment_date_filter')) {
        this.filterConstant[0].push({
          type: 'Date',
          category: this.filters.SCH_DATE,
          defaultStartDate: this.defaultValues.startDate,
          defaultEndDate: this.defaultValues.endDate,
          startDate: this.defaultValues.startDate,
          endDate: this.defaultValues.endDate,
          start_date_label: 'shipment_start',
          end_date_label: 'shipment_end',
          optional: false,
          maxDays: 366,
        });
      }
    },
    reportChange(reportRadio) {
      this.selectedReport = reportRadio;
    },
    constructParams() {
      if (this.selectedReport) {
        let params = null;
        params = this.constructFilterPayload();
        if (params && params.error) {
          this.$errorMessage({ message: params.error });
          return null;
        }
        if (this.singleDayReports.includes(this.reports[this.selectedReport - 1].name)) {
          params = Object.assign(params, { date: params.start });
          delete params.start;
          delete params.end;
        } else if (this.reports[this.selectedReport - 1].name === 'Primary Delay') {
          params = Object.assign(params, { depot_type: 1 });
        } else if (this.reports[this.selectedReport - 1].name === 'Secondary Delay') {
          params = Object.assign(params, { depot_type: 2 });
        }
        return params;
      }
    },
    async generateReport() {
      try {
        this.$addGAEvent('Reports', 'Generate report', this.reports[this.selectedReport - 1].name);
        const params = this.constructParams();
        if (params) {
          const data = { report: this.reports[this.selectedReport - 1], params };
          const result = await this.$store.dispatch(`report/${this.reports[this.selectedReport - 1].emitMethod}`, data);
          if (result && result.data) {
            this.$successMessage({ message: result.data.message });
          } else if (result && result.error) {
            this.$errorMessage({ message: result.error });
          }
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('APP_CATCH_ERR') });
      }
    },
    resetApply() {
      this.resetAll();
      this.applyFilters();
      this.resetSelectedReport();
    },
    apply() {
      this.$addGAEvent('Reports', 'Click', 'Apply filter');
      this.applyFilters();
    },
    callGA() {
      this.$addGAEvent('Reports', arguments[0], arguments[1]);
    },
    updateOptionWithGA() {
      this.updateOption(...arguments);
      this.setGAForTransporter(...arguments);
      this.apply();
      this.resetSelectedReport();
    },
    setGAForTransporter(index1, index2, data) {
      if (this.filterConstant[index1][index2].category === this.filters.TRANSPORTER) {
        if (data.id === 0) {
          this.$addGAEvent('Reports', 'Click', 'Select all transporters filter');
        }
      }
    },
  },
};
</script>
